var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","disabled":_vm.isSend},on:{"click":_vm.sendCodeFn}},[_vm._v(_vm._s(_vm.isSend ? _vm.sendTime + 's' : '发送验证码'))])}
var staticRenderFns = []

export { render, staticRenderFns }